import { FlexXY } from "../components/common/flexBox";
import TabComponent from "../components/home/tabComponent";
import styled from "styled-components";
import { Cookies } from "react-cookie";
import IntroductionVideoList from "../components/introduction/introductionVideoList";
import IntroductionImageList from "../components/introduction/introductionImageList";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  /* background-color: red; */
  width: 90%;
  height: 100%;
`;

const ListArea = styled.div`
  margin-top: 4vw;
  width: 100%;
  height: 38vw;
`;

const VideoArea = styled.div`
  margin-top: 4vw;
  margin-bottom: 4vw;
  width: 100%;
  /* outline: 1px solid red; */
`;
export default function Introduction() {
  return (
    <>
      <FlexXY>
        <Container>
          <ListArea>
            <IntroductionImageList></IntroductionImageList>
          </ListArea>
          <VideoArea>
            <IntroductionVideoList></IntroductionVideoList>
          </VideoArea>
        </Container>
      </FlexXY>
    </>
  );
}
